const initializeReferralCodeHelper = () => {
  const params = new URLSearchParams(window.location.search);

  if (!params.has('referral_code')) {
    return;
  }

  const referralCode = params.get('referral_code');
  const referredByFields = document.querySelectorAll(
    "input[name='referred_by']"
  );

  referredByFields.forEach((field) => {
    field.value = referralCode;
  });
};

export { initializeReferralCodeHelper };
